import { App } from 'vue'

import DOMPurify from 'dompurify'
import { install } from '@/plugins/w/loggly'
import { useAppStore } from '@/plugins/app/_config/store'
import { useCacheStore } from '@/plugins/app/_config/cache.store'

export const dompurify = (html: string) =>
	DOMPurify.sanitize(html, {
		// OC: Preco je tu toto?
		ADD_ATTR: ['target']
	})

export default (app: App) => {
	const appStore = useAppStore()
	const cacheStore = useCacheStore()

	const IS_LOGGLY_ACTIVE = false // set to true to enable loggly logging

	app.config.globalProperties.$appStore = appStore
	app.config.globalProperties.$cacheStore = cacheStore

	if (IS_LOGGLY_ACTIVE) {
		const wLogger = install()
		app.config.globalProperties.$wLogger = wLogger
		app.config.globalProperties.$wLogger.setupInterceptors([])
	}
}
